<template>
  <div>
    <el-dialog :visible.sync="dialogCodeVisible" top="2%" @close="handleClose">
      <span slot="title">审方进度</span>
      <div style="height: 500px; overflow: auto">
        <div class="prescription-progress-box" v-loading="loading">
          <el-steps
            direction="vertical"
            :active="stepActive"
            style="margin-left: 100px"
          >
            <el-step v-for="(item, index) in stepList" :key="index">
              <i
                slot="icon"
                :class="item.icon"
                :style="{ color: item.color }"
              ></i>
              <div slot="title">
                <div class="prescription-title">{{ item.operateName }}</div>
              </div>
              <div slot="description">
                <div class="prescription-desc">
                  <div
                    class="prescription-desc-item"
                    v-for="operatorsItem in item.operators"
                    :key="operatorsItem.operatorName"
                  >
                    <span style="margin-right: 5px">{{
                      operatorsItem.operatorName
                    }}</span>
                    <span
                      class="prescription-desc-item-job"
                      v-for="v in operatorsItem.jobs"
                      :key="v"
                      >{{ v }}</span
                    >
                  </div>
                  <div class="prescription-desc-item">{{ item.storeName }}</div>
                  <div class="prescription-desc-item">{{ item.storeArea }}</div>
                  <div class="prescription-desc-time">
                    <div>{{ item.operatorTime.split(" ")[0] }}</div>
                    <div>{{ item.operatorTime.split(" ")[1] }}</div>
                  </div>
                  <div
                    :class="[
                      'prescription-desc-item',
                      item.operationType === 4 || item.operationType === 6
                        ? 'red'
                        : 'green',
                      item.operationType === 7 ? 'isClick' : '',
                    ]"
                    v-if="item.reason"
                    @click="handleClick(item)"
                  >
                    {{ item.reason }}
                    <i
                      class="el-icon-d-arrow-right"
                      v-if="item.operationType === 7"
                    ></i>
                  </div>
                </div>
              </div>
            </el-step>
          </el-steps>
        </div>
      </div>
    </el-dialog>

    <ConfirmPay ref="ConfirmPayRef" />
  </div>
</template>

<script>
import ConfirmPay from "./confirmPay.vue";

export default {
  name: "PrescriptionProgress",
  components: {
    ConfirmPay,
  },
  props: {},
  data() {
    return {
      loading: false,
      dialogCodeVisible: false,
      stepActive: 0,
      stepList: [],
      prescriptionId: "",
    };
  },
  methods: {
    handleClick(item) {
      if (item.operationType === 7) {
        this.$refs.ConfirmPayRef.show({
          id: this.prescriptionId,
          isMedicinePaidStatus: 1,
        });
      }
    },
    handleClose() {
      this.dialogCodeVisible = false;
    },
    async show(row) {
      this.dialogCodeVisible = true;
      this.loading = true;
      let { data } = await this.$api.prescription.GetPrescriptionProgress({
        prescriptionId: row.id,
      });
      this.prescriptionId = row.id;
      this.loading = false;
      data.forEach((item) => {
        item.icon = "el-icon-success";
        item.color = "#4076f2";
        if (item.operationType === 4) {
          item.icon = "el-icon-warning";
          item.color = "#FF3A3A";
        }
        if (item.operationType === 6) {
          item.icon = "el-icon-error";
          item.color = "#FF3A3A";
        }
      });
      this.stepList = data;
    },
  },
};
</script>

<style scoped>
::v-deep .el-dialog__header {
  background: #f7f7f7 !important;
  border-radius: 4px 4px 0px 0px !important;
  border-bottom: 1px solid #dcdcdc !important;
}
::v-deep .prescription-progress-box .el-step__icon {
  border: none !important;
  font-size: 25px !important;
}
</style>
<style lang="scss" scoped>
@import "./prescriptionProgress.scss";
</style>
